export default "__VITE_ASSET__CGVmmv6i__"